// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PersonalApiKey
 */
export interface PersonalApiKey {
  /**
   *
   */
  name: string;
  /**
   *
   */
  prefix: string;
  /**
   *
   */
  key: string;
  /**
   *
   */
  scope: string;
  /**
   *
   */
  revoked: boolean;
  /**
   *
   */
  organisations: Array<string>;
}

/**
 * Check if a given object implements the PersonalApiKey interface.
 */
export function instanceOfPersonalApiKey(value: object): value is PersonalApiKey {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("prefix" in value) || value["prefix"] === undefined) return false;
  if (!("key" in value) || value["key"] === undefined) return false;
  if (!("scope" in value) || value["scope"] === undefined) return false;
  if (!("revoked" in value) || value["revoked"] === undefined) return false;
  if (!("organisations" in value) || value["organisations"] === undefined) return false;
  return true;
}

export function PersonalApiKeyFromJSON(json: any): PersonalApiKey {
  return PersonalApiKeyFromJSONTyped(json, false);
}

export function PersonalApiKeyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PersonalApiKey {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    prefix: json["prefix"],
    key: json["key"],
    scope: json["scope"],
    revoked: json["revoked"],
    organisations: json["organisations"],
  };
}

export function PersonalApiKeyToJSON(json: any): PersonalApiKey {
  return PersonalApiKeyToJSONTyped(json, false);
}

export function PersonalApiKeyToJSONTyped(
  value?: PersonalApiKey | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    prefix: value["prefix"],
    key: value["key"],
    scope: value["scope"],
    revoked: value["revoked"],
    organisations: value["organisations"],
  };
}
